import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { WS_MESSAGE_TYPE } from 'cpool-constants';

import { wsClient } from '~/api/wsClient';
import {
    ALL_NOTIFICATION_QUERY_KEYS,
    NOTIFICATIONS_FALLBACK_RESYNC_INTERVAL_MS,
} from '~/features/notifications/constants';
import { handleNotificationsSocketMessage } from '~/features/notifications/utils/handleNotificationsSocketMessage';

// App-shell-level bell handler — mounted once (via NotificationsLiveUpdates) for roles that show the bell.
export function useNotificationsSocket(): void {
    const queryClient = useQueryClient();

    useEffect(() => {
        const resync = () =>
            ALL_NOTIFICATION_QUERY_KEYS.forEach((queryKey) => queryClient.invalidateQueries({ queryKey }));

        wsClient.registerHandler(WS_MESSAGE_TYPE.NOTIFICATIONS, {
            onMessage: (message) => {
                handleNotificationsSocketMessage({ message, queryClient });
            },
            // Resync on (re)connect — pushes during socket downtime are lost.
            onOpen: resync,
        });
        const fallbackResync = setInterval(resync, NOTIFICATIONS_FALLBACK_RESYNC_INTERVAL_MS);

        return () => {
            wsClient.unregisterHandler(WS_MESSAGE_TYPE.NOTIFICATIONS);
            clearInterval(fallbackResync);
        };
    }, [queryClient]);
}
